"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAchievementsMock = exports.mockTeamsLeaderboard = exports.mockUsersLeaderboard2 = exports.mockUsersLeaderboard = exports.mockCompletionData = exports.mockWeeklyChallenge = void 0;
exports.mockWeeklyChallenge = {
    data: {
        content_challenge_uuid: '327edwsbd289yhsqwjuhsd',
        url: '/codebashing-game-of-hacks/index.html?content_game_uuid=327edwsbd289yhsqwjuhsd',
        max_points: 10000,
        name: 'Fundamental Challenge for C#',
        language: 'C#',
        total_leaderboard_users: 6,
        top_leaderboard: [
            {
                nickname: 'User3',
                score: 9475,
                profile_picture: 'https://picsum.photos/200?random=3',
            },
            {
                nickname: 'User1',
                score: 7652,
                profile_picture: 'https://picsum.photos/200?random=1',
            },
            {
                nickname: 'User5',
                score: 7450,
                profile_picture: 'https://picsum.photos/200?random=5',
            },
            {
                nickname: 'User2',
                score: 6188,
                profile_picture: 'https://picsum.photos/200?random=2',
            },
        ],
        my_position: 2,
        my_score: 7652,
    },
};
var mockPendingTasks = {
    primary_course: {
        total: 1,
        next_lesson_url: '/courses/java/lessons/sql_injection',
        next_lesson_display_name: 'SQL Injection',
    },
    assigned_lessons: {
        total: 3,
        next_lesson_url: '/courses/java/lessons/command_injection',
        next_lesson_display_name: 'Command Injection',
    },
    assessments: {
        total: 1,
        next_assessment_url: '/assessments/take?assessment_id=225',
        next_assessment_display_name: 'Yearly Assessment',
    },
};
var mockCompletionRate = {
    primary_course: {
        total_lessons: 139,
        completed_lessons: 139,
        percent: 100,
    },
    assigned_lessons: {
        total_lessons: 148,
        completed_lessons: 142,
        percent: 95,
    },
    assessments: {
        total_assessments: 4,
        completed_assessments: 2,
        percent: 50,
    },
};
exports.mockCompletionData = {
    pending_tasks: mockPendingTasks,
    data: mockCompletionRate,
};
exports.mockUsersLeaderboard = {
    current_user: {
        rank: 8,
        nickname_or_email: 'User8',
        score: 500,
        profile_picture: 'https://picsum.photos/200?random=1',
        uuid: 'a',
    },
    users: [
        {
            rank: 1,
            nickname_or_email: 'User1',
            score: 18900,
            profile_picture: 'https://picsum.photos/200?random=1',
            uuid: 'b',
        },
        {
            rank: 2,
            nickname_or_email: 'User2',
            score: 17600,
            profile_picture: 'https://picsum.photos/200?random=2',
        },
        {
            rank: 3,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
            uuid: 'c',
        },
    ],
    total_users: 45,
};
exports.mockUsersLeaderboard2 = {
    current_user: {
        rank: 8,
        nickname_or_email: 'User8',
        score: 500,
        profile_picture: 'https://picsum.photos/200?random=1',
        uuid: 'a',
    },
    users: [
        {
            rank: 21,
            nickname_or_email: 'User1',
            score: 18900,
            profile_picture: 'https://picsum.photos/200?random=1',
            uuid: 'a',
        },
        {
            rank: 22,
            nickname_or_email: 'User2',
            score: 17600,
            profile_picture: 'https://picsum.photos/200?random=2',
            uuid: 'b',
        },
        {
            rank: 23,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
        },
        {
            rank: 24,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
            uuid: 'c',
        },
        {
            rank: 25,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
            uuid: 'd',
        },
        {
            rank: 26,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
            uuid: 'e',
        },
        {
            rank: 27,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
        },
        {
            rank: 28,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
            uuid: 'f',
        },
        {
            rank: 29,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
            uuid: 'g',
        },
        {
            rank: 30,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
            uuid: 'h',
        },
        {
            rank: 31,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
            uuid: 's',
        },
        {
            rank: 32,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
        },
        {
            rank: 33,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
        },
        {
            rank: 34,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
        },
        {
            rank: 35,
            nickname_or_email: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
        },
        {
            rank: 36,
            nickname: 'User3',
            score: 14200,
            profile_picture: 'https://picsum.photos/200?random=3',
        },
    ],
    total_users: 45,
};
exports.mockTeamsLeaderboard = {
    my_teams: [
        {
            id: 1,
            rank: 1,
            team_score: 305700,
            team_members: 13,
            team_name: 'Team1',
        },
        {
            id: 2,
            rank: 2,
            team_score: 305700,
            team_members: 13,
            team_name: 'Team1',
        },
        {
            id: 5,
            rank: 5,
            team_score: 305700,
            team_members: 13,
            team_name: 'Team1',
        },
    ],
    all_teams: [
        {
            id: 1,
            rank: 1,
            team_score: 305700,
            team_members: 13,
            team_name: 'Team1',
        },
        {
            id: 2,
            rank: 2,
            team_score: 305700,
            team_members: 13,
            team_name: 'Team1',
        },
        {
            id: 3,
            rank: 3,
            team_score: 305700,
            team_members: 13,
            team_name: 'Team1',
        },
    ],
    total_teams: 45,
};
exports.userAchievementsMock = {
    user_badges: ['god'],
    user_points: 5555,
};
